import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useTranslation } from "core/hooks/useTranslation";

import { Form } from 'antd';

import { saveMedia } from 'store/actions/portal/marketingTools/mediaTools/mediaTools.actions';

import Modal from "components/common/modal";
import MediaSaveForm from './form';

import useAutosuggestion from 'hooks/useAutosuggestion';

import { POPUP_SIZE } from "constants/common.constants";
import { AUTOSUGGESTION_TYPE } from 'constants/autosuggestion.constants';

const SaveMedia = ({
    onClose,
    formInitialValues = {
        trafficSources: []
    },
    saveMedia,
    isSaving
}) => {
    const { t } = useTranslation();

    const [isFormTouched, setIsFormTouched] = useState(false);

    const [formInstance] = Form.useForm();

    const { validateFields } = formInstance;

    const [ trafficSources ] = useAutosuggestion({
        type: AUTOSUGGESTION_TYPE.TRAFFIC_SOURCES,
        dependencies: [],
        actionParams: { affiliateId: formInitialValues.affiliateId },
    });


    const handleForm = () => {
        validateFields()
            .then(formData => {
                const requestBody = {
                    name: formData.name,
                    traficSources: formData.trafficSources?.filter(Boolean),
                    id: formInitialValues.id
                }
                saveMedia(
                    requestBody,
                    onClose
                )
            }).catch(ex => {
                console.log(ex)
            })
    }

    return (
        <Modal
            title={t('backoffice.campaigns.editMedia')}
            okText={t('backoffice.common.save')}
            cancelText={t('backoffice.common.cancel')}
            onOk={handleForm}
            disableOkButton={!isFormTouched}
            onCancel={onClose}
            size={ POPUP_SIZE.SMALLEST}
            isLoading={isSaving}
        >
            <MediaSaveForm
                formInstance={formInstance}
                formInitialValues={formInitialValues}
                trafficSources={trafficSources}
                onValuesChange={ (_, formValues) => setIsFormTouched( formInitialValues?.name !== formValues.name || formInitialValues?.trafficSources !== formValues.trafficSources )}
            />
        </Modal>
    )
}

/** SaveMedia propTypes
    * PropTypes
*/
SaveMedia.propTypes = {
    /** Fires on popup close */
    onClose: PropTypes.func,
    /** Redux action to save media  */
    saveMedia: PropTypes.func,
    /** Redux state property, is true when saving media tools */
    isSaving: PropTypes.bool,
    /** Form Initial Values */
    formInitialValues: PropTypes.object
}

const mapDispatchToProps = dispatch => ({
    saveMedia: (requestBody, onSuccess) => {
        dispatch(saveMedia(requestBody, onSuccess));
    },
})

const mapStateToProps = state => {
    return {
        isSaving: state.mediaTools.isSaving,
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SaveMedia)